<script>
  export default {
    props: {},
    data() {
      return {}
    },
    methods: {},
    computed: {},
    watch: {},
    components: {},
    mounted() {
    },
    destroyed() {
    }
  }
</script>
<template>
  <div class="footer">
    © 2011-2018 MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel
  </div>
</template>